import axios from 'axios'

const EXAM_ORIGIN = 'https://www.e-snails.com'

/** 真题文档下载域名（与线上资源路径拼接） */
export const EXAM_FILE_BASE = 'https://file.e-snails.com/spath/'

const examClient = axios.create({
  baseURL: EXAM_ORIGIN,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

export function getTallClassifyList () {
  return examClient.post('/official/examHall/getTallClassifyList', {})
}

export function getTallPage (body) {
  return examClient.post('/official/examHall/getTallPage', body)
}
